const { ProxifiedEntityApi } = require('../common')
const { VEHICLE_CLASS } = require('../routes/tools')
const CarrierPGAdapter = require('./data-access/carrier-pg-adapter')

class CarrierApi extends ProxifiedEntityApi {
  constructor (state, pgConnection, agaveAdapter, logger) {
    const { user } = state

    const adapter = new CarrierPGAdapter(logger, pgConnection, user.name)
    super(
      'carrier',
      ['create', 'update', 'list', 'get'],
      !pgConnection,
      adapter,
      agaveAdapter
    )

    this.adapter = adapter
  }

  // List carriers operating in a given state
  async listCarriersByState ({ country, state } = {}) {
    if (!state) return []
    const { organisations } = await this.list({ type: 'carrier', country })
    const isNational = state === 'national'
    return organisations.reduce((acc, org) => {
      const { organisation, fleetCategories, operationalStates } = org
      const fleet = fleetCategories.map(vehicule => {
        const { name: category, displayName: name, maxVolume } = VEHICLE_CLASS.find(vc => vc.name === vehicule.category) || {}
        return {
          category,
          name,
          maxVolume
        }
      })
      if (isNational) {
        acc.push({ ...organisation, fleet })
        return acc
      }
      const priority = (operationalStates.find(s => s.state === state) || {}).priority
      if (priority) {
        acc.push({ ...organisation, fleet, priority })
      }
      return acc
    }, [])
  }

  // List carriers operating in any of the given states
  async listCarriersByStates ({ country, states } = {}) {
    if (!states || !states.length) return []
    const { organisations } = await this.list({ type: 'carrier', country })
    const seen = new Map()
    for (const org of organisations) {
      const { organisation, fleetCategories, operationalStates } = org
      const fleet = fleetCategories.map(vehicule => {
        const { name: category, displayName: name, maxVolume } = VEHICLE_CLASS.find(vc => vc.name === vehicule.category) || {}
        return { category, name, maxVolume }
      })
      for (const state of states) {
        const match = operationalStates.find(s => s.state === state)
        if (match && !seen.has(organisation.id)) {
          seen.set(organisation.id, { ...organisation, fleet, priority: match.priority })
        }
      }
    }
    return Array.from(seen.values())
  }
}

module.exports = CarrierApi
